// Small date helpers the booking and payment pages share. Pure.

/** "1st", "2nd", "11th", "23rd" (moment's "Do"). */
export function ordinal(n: number): string {
  const tens = n % 100;
  const suffix = tens > 10 && tens < 14 ? "th" : (["th", "st", "nd", "rd"][n % 10] ?? "th");
  return `${n}${suffix}`;
}

/** Whether a value is a date string that parses. */
export const isValidDate = (iso: string | null | undefined): iso is string => !!iso && !Number.isNaN(new Date(iso).getTime());
